import { Container, Htag, HtagAlign, HtagVariant } from '../../components';
import styles from './logistic-questions.module.css';

export default function LogisticQuestion() {
  return (
    <div className={styles.root}>
      <Container>
        <Htag
          variant={HtagVariant.h2}
          align={HtagAlign.center}
          className={styles.title}
          tag="h2"
        >
          Frequently asked questions
        </Htag>

        <ul className={styles.list}>
          <li className={styles.item}>
            <div className={styles.card}>
              <p className={styles.card_text}>
                How Much Time and Money Will You Take To Build Logistics
                Software?
              </p>
            </div>
          </li>
          <li className={styles.item}>
            <div className={styles.card}>
              <p className={styles.card_text}>
                How does a logistics app development company help businesses to
                improve its work?
              </p>
            </div>
          </li>
          <li className={styles.item}>
            <div className={styles.card}>
              <p className={styles.card_text}>
                Why transportation and logistics companies need a mobile app?
              </p>
            </div>
          </li>

          <li className={styles.item}>
            <div className={styles.card}>
              <p className={styles.card_text}>
                How long do you provide support after sales?
              </p>
            </div>
          </li>
        </ul>
      </Container>
    </div>
  );
}
